const Pikaday = require("pikaday");
const Moment = require("moment");

const selector = "[data-filters]";
const chosenDateClass = "date-chosen";
const datepickerOpenClass = "datepicker-open";

let els = null;

function Filters() {
	// Search for carousel elements on page
	els = document.querySelectorAll(selector);

	// If there are any, continue
	if (els.length) {
		init();
	}
}

const init = () => {
	// Loop through each filters set
	[].forEach.call(els, function (item) {
		// Find if there's a date field in this filters block
		const dateFilter = item.querySelector('[name="date"]');

		// If there IS...
		if (dateFilter !== null) {
			let currDate = dateFilter.value;
			const filterContainer = dateFilter.closest(".select").parentNode;

			// Add hidden field for datepicker to bind to
			const dpHiddenFld = document.createElement("input");
			dpHiddenFld.type = "hidden";
			dpHiddenFld.name = "dp-hidden-fld";
			dpHiddenFld.dataset.specificDate = true;
			item.prepend(dpHiddenFld);

			// Add "Pick A Date" option to date field
			const opt = document.createElement("option");
			opt.value = "pick-a-date";
			opt.text = "Pick A Date";
			dateFilter.add(opt, null);

			// Get element to show chosen date
			const chosenDateEl = item.querySelector(".chosen-date");
			if (chosenDateEl !== null) {
				const chosenDateElCloseBtn = chosenDateEl.querySelector("button");
				if (chosenDateElCloseBtn !== null) {
					chosenDateElCloseBtn.addEventListener("click", function (e) {
						// Dispatch "date-chosen" event
						const closeChosenDateEvent = new Event("chosen-date-closed", {
							bubbles: true,
						});
						chosenDateElCloseBtn.dispatchEvent(closeChosenDateEvent);
					});
				}
			}

			const pickerConfig = {
				field: dpHiddenFld,
				container: filterContainer,
				format: "YYYY-MM-DD",
				onSelect: function () {
					// Add chosen date to display element
					chosenDateEl.querySelector("[data-chosen-date-text]").innerHTML = this.getMoment().format("Do MMMM YYYY");

					// Remove datepicker open class
					filterContainer.classList.remove(datepickerOpenClass);

					// Add class to show date has been chosen
					filterContainer.classList.add(chosenDateClass);

					// Dispatch "date-chosen" event
					const dateChosenEvent = new CustomEvent("date-chosen", {
						bubbles: true,
						detail: this.getMoment().format("YYYY-MM-DD"),
					});
					item.dispatchEvent(dateChosenEvent);

					this.hide();
				},
				onClose: function () {
					console.log("Closing datepicker");

					// Remove datepicker open class
					filterContainer.classList.remove(datepickerOpenClass);

					// Change date picker selected date back to today
					dateFilter.value = currDate;
				},
			};

			if (item.hasAttribute("data-initial-date")) {
				pickerConfig.defaultDate = Moment(item.getAttribute("data-initial-date"), "YYYY-MM-DD").toDate();
				pickerConfig.setDefaultDate = true;
			}

			// Add datepicker to filters block
			const picker = new Pikaday(pickerConfig);

			// Listen for datepicker close click
			filterContainer.addEventListener("datepicker-close-click", function (e) {
				console.log("datepicker-close-click");

				picker.hide();
				filterContainer.classList.remove(datepickerOpenClass);
			});

			// Additional element to close datepicker
			const dpCloseBtn = filterContainer.querySelector("[data-close-datepicker]");
			dpCloseBtn.addEventListener("click", function (e) {
				console.log("Clicked date picker close button");

				// Create custom event to pass up
				const datepickerCloseClickedEvent = new CustomEvent("datepicker-close-click", {
					bubbles: true,
				});

				dpCloseBtn.dispatchEvent(datepickerCloseClickedEvent);
			});

			// When date filter is changed...
			dateFilter.addEventListener("change", function (e) {
				// If "Pick A Date" selected...
				if (dateFilter.value == "pick-a-date") {
					console.log("Pick a date chosen");

					// Trigger datepicker to open

					setTimeout(function () {
						picker.show();
					}, 0);

					// Add class to parent item
					filterContainer.classList.add(datepickerOpenClass);

					console.log(filterContainer);
				} else {
					console.log("hiding datepicker");

					// Remove class to parent item
					filterContainer.classList.remove(datepickerOpenClass);

					// Close datepicker
					picker.hide();

					// Get new date value
					currDate = dateFilter.value;
				}
			});

			// Listen for when a chosen date has been closed
			item.addEventListener("chosen-date-closed", function (e) {
				console.log("Chosen date closed");

				const chosenDateEl = e.target;

				// Default back to "Any Date"
				dateFilter.value = "any";

				// Create custom event to pass up list of filter values
				const filterChangeEvent = new Event("date-closed", {
					bubbles: true,
				});

				// Dispatch custom event
				item.dispatchEvent(filterChangeEvent);

				// Remove class to hide chosen-date element
				chosenDateEl.closest("[data-filters-list-item]").classList.remove(chosenDateClass);
			});
		}

		// Listen for any change events inside filters
		item.addEventListener("change", function (e) {
			// Get changed field
			const changedField = e.target;

			// Only dispatch "filter-change" event if changed field was a select
			if (changedField.tagName == "SELECT") {
				// Create custom event to pass up list of filter values
				const filterChangeEvent = new CustomEvent("filter-change", {
					bubbles: true,
					detail: changedField.value,
				});

				// Dispatch custom event
				item.dispatchEvent(filterChangeEvent);
			}
		});
	});
};

export default Filters;
